module.exports = __webpack_public_path__ + "496796b92e74d722be052d700ec1ba02.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/5.jpg
// module id = 523
// module chunks = 0